import {
	SET_POSITIONS,
	SET_POSITION,
	CLEAR_POSITIONS,
	CLEAR_POSITION,
	ADD_POSITION,
	UPDATE_POSITION,
	REMOVE_POSITION,
} from './actionTypes';

export const position = (state = {}, action) => {
	switch (action.type) {
		case SET_POSITION:
			return action.payload;
		case UPDATE_POSITION:
			if (state._id.toString() !== action.payload._id.toString()) {
				return state;
			}

			// Otherwise, this is the one we want - return an updated value
			return {
				...state,
				...action.payload,
			};
		case CLEAR_POSITION:
			return {};
		default:
			return state;
	}
};

export default (state = [], action) => {
	switch (action.type) {
		case SET_POSITIONS:
			return action.payload;
		case ADD_POSITION:
			return [...state, action.payload];
		case UPDATE_POSITION:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
					...action.payload,
				};
			});
		case REMOVE_POSITION:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
				};
			});
		case CLEAR_POSITIONS:
			return [];
		default:
			return state;
	}
};
